import { render, staticRenderFns } from "./Voting.vue?vue&type=template&id=40e94a70&scoped=true&lang=pug&"
import script from "./Voting.vue?vue&type=script&lang=js&"
export * from "./Voting.vue?vue&type=script&lang=js&"
import style0 from "./Voting.vue?vue&type=style&index=0&id=40e94a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e94a70",
  null
  
)

export default component.exports